import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';
import { BrowserRouter as Router} from 'react-router-dom';
import { Route } from 'react-router-dom';
import './index.css';
import App from './users/views/Dashboard';
import * as serviceWorker from './serviceWorker';

const trackingId = "UA-157804322-1"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId)

const history = createBrowserHistory();

history.listen(location => {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname); // Record a pageview for the given page
  });

ReactDOM.render(
    <Router basename='/' history={history}>
        <App />
    </Router>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
